import { useTranslation } from "react-i18next";
import { useSSRContext } from "../../context/SSRContext";
import { Divider } from "antd";

export default function FlightTitle() {
  const { t } = useTranslation();
  const { flightOptions, cursor } = useSSRContext();

  const currentFlight = flightOptions.find((flight) => flight.value === cursor.flightId);
  if (!currentFlight) return null;

  const { segmentIndex, flightIndex, origin, destination } = currentFlight;
  const segmentFlights = flightOptions.filter((flight) => flight?.segmentIndex === segmentIndex);
  const label = segmentIndex === 0 ? t("Flights.search.departure") : t("Flights.search.return");
  const title = `${origin.code} ${t("Flights.search.to")} ${destination.code}`;
  const counter = t("Flights.details.ssr.flightOfTotal", { current: flightIndex + 1, total: segmentFlights.length });

  return (
    <div className="flex flex-col gap-4 py-4">
      <div className="flex w-full items-center justify-between gap-4">
        <div className="flex flex-col gap-1">
          <span className="text-font-minimal text-xs font-medium uppercase tracking-wide">{label}</span>
          <span className="text-font-default text-lg font-semibold uppercase leading-tight md:text-2xl">{title}</span>
        </div>
        <span className="text-font-subtle shrink-0 px-3 py-1 text-xs font-medium">{counter}</span>
      </div>
      <Divider className="m-0! bg-border-default!"/>
    </div>
  );
}
